<template>
<div>
  <div v-if="debugMode">
    <p v-if="resultData.error">{{ resultData.error }}</p>
    <p v-if="resultData.shouldLoadData">Loading data... {{ resultData.loadingPercent }}%</p>
    <p v-else>Results complete</p>
  </div>

  <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3">
    <h2 class="h2">Pages Found</h2>
    <div class="btn-toolbar mb-2 mb-md-0">
      <div class="btn-group me-2">
        <a :href="shareEmailLink" type="button" class="btn btn-sm btn-outline-secondary">
          Share
        </a>
        <a :href="this.backendHost + '/csv/' + this.crawlId" class="btn btn-sm btn-outline-secondary">
          Export CSV
        </a>
      </div>
      <!--
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary dropdown-toggle"
      >
        <span data-feather="calendar"></span>
        This week
      </button>
      -->
    </div>
  </div>
  <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
      <a href="#" @click.prevent="this.$router.push({name: 'productResults'})">[ Switch to Products Found ]</a>
  </div>

  <div
    class="
      d-flex
      justify-content-between
      flex-wrap flex-md-nowrap
      align-items-center
    "
  >
        <h4 class="h4 text-truncate">
          <span v-for="link in resultData.initialLinks" :key="link" :title="link">
            <i class="bi-check-circle-fill pe-2"></i>{{ link }}
          </span>      
        </h4>
  </div>
  <div v-if="resultData.loadingPercent < 100" class="progress">
    <div class="progress-bar" role="progressbar" :style="'width:' + resultData.loadingPercent + '%;'" :aria-valuenow="resultData.loadingPercent" aria-valuemin="0" aria-valuemax="100">{{ resultData.loadingPercent }}%</div>
  </div>
  <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3">
    <div class="input-group mb-3">
      <input class="form-control" type="text" v-on:keyup.enter="applyPageFilter" ref="filterInput" placeholder="Search by keyword" aria-label="Search by keyword">
      <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="applyPageFilter">Search</button>
    </div>
  </div>


  <div v-if="pageFilter" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
    <h5>Showing results with keywords:</h5>
  </div>
  <div v-if="pageFilter" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 pd-3">
    <span>"{{ this.pageFilter }}" <a href="#" @click.prevent="clearPageFilter"> <i class="bi-trash-fill px-1"></i>[ Remove keyword ]</a></span>
  </div>

  <div v-if="currentProductFilter" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
    <h5>Showing pages containing product:</h5>
  </div>
  <div v-if="currentProductFilter" class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 pb-3">
    <div class="row">
        <div class="col-md-4 col">
          <a href="#" @click.prevent="currentProductFilter=null"><i class="bi-trash-fill px-1"></i>[ Remove product filter ]</a>
          <product-card :metadata="currentProductFilter"></product-card>
        </div>
    </div>
  </div>
  
  <div class="table-responsive">
    <table class="table table-striped table-sm">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col" @click="togglePageSort">Page<i :class="pageSortClasses"></i></th>
          <th scope="col" @click="toggleProductSort">Products<i :class="productSortClasses"></i></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(amazonItem, index) in sortedFilteredAmazonItems"
          :key="amazonItem.url"
        >
          <td>{{ index + 1 }}</td>
          <template v-if="amazonItem.uniqueMetadataList.length">
            <td><a href="#" @click.prevent="showPageProducts(amazonItem)"><i class="bi-zoom-in px-2"></i>{{ amazonItem.url }}</a></td>
            <td><a href="#" @click.prevent="showPageProducts(amazonItem)">{{ amazonItem.uniqueMetadataList.length }}</a></td>
          </template>
          <template v-else>
            <td><i class="bi-zoom-in px-2"></i>{{ amazonItem.url }}</td>
            <td>None</td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</div> 
</template>
<script>
import ProductCard from '../components/ProductCard.vue';

export default {
  components: {
    ProductCard
  },
  props: {
    crawlId: String,
    productFilter: String,
    resultData: Object
  },
  data() {
    return {
      debugMode: false,
      pageFilter: null,
      sort: 'productDesc',
      currentProductFilter: this.parseFilter(this.productFilter),
      affiliateTagFilter: null
    };
  },
  methods: {
    filterItemsByAffiliateTagMismatch(inputItems) {
      if (! this.affiliateTagFilter) {
        return inputItems;
      }

      const matchingItems = [];
      for (const amazonItem of inputItems) {
        //console.log("Inspecting...", amazonItem.uniqueMetadataList)

        const foundItem = amazonItem.uniqueMetadataList.find(amazonMetadataLink => {
          if (amazonMetadataLink.amazonMetadata.trialLimitReached) {
            return false;
          }
          const result = ('' + amazonMetadataLink.amazonMetadata.affiliateTag) !== this.affiliateTagFilter
          //console.log(amazonMetadataLink, ('' + amazonMetadataLink.amazonMetadata.productPage), result)
          return result
        });

        if (foundItem) {
          matchingItems.push(amazonItem);
        }
      }

      return matchingItems;
    },
    filterItemsByPage(inputItems) {
      if (! this.pageFilter) {
        return inputItems;
      }

      const terms = this.pageFilter.split(" ");
      const filteredAmazonItems = [];

      for (const amazonItem of inputItems) {
        let matchedTerms = 0;
        for (const term of terms) {
          if (amazonItem.url.toLowerCase().includes(term)) {
            matchedTerms++;
          }
        }
        if (terms.length === matchedTerms) {
          filteredAmazonItems.push(amazonItem);
        }
      }

      return filteredAmazonItems;
    },
    filterItemsByProduct(inputItems) {
      if (! this.currentProductFilter) {
        return inputItems;
      }

      const matchingProductItems = [];
      for (const amazonItem of inputItems) {
        //console.log("Inspecting...", amazonItem.uniqueMetadataList)

        const foundItem = amazonItem.uniqueMetadataList.find(amazonMetadataLink => {
          const result = ('' + amazonMetadataLink.amazonMetadata.productPage) === this.currentProductFilter.amazonMetadata.productPage
          //console.log(amazonMetadataLink, ('' + amazonMetadataLink.amazonMetadata.productPage), result)
          return result
        });

        if (foundItem) {
          matchingProductItems.push(amazonItem);
        }
      }

      return matchingProductItems;
    },
    parseFilter(filterString) {
      if (! filterString) {
        return null;
      }
      //console.log("String filter", filterString)
      const filter = JSON.parse(filterString);
      //console.log("Parsed filter", filter);
      return filter;
    },
    showPageProducts(item) {
      console.log("Selecting URL: " + item.url)
      this.$router.push({
        name: 'productResults',
        params: {
          selectedPageFilter: item.url
        }
      })
    },
    toggleProductSort() {
      if (this.sort === 'productAsc') {
        this.sort = 'productDesc'
      }
      else if (this.sort === 'productDesc') {
        this.sort = 'productAsc'
      } else {
        this.sort = 'productAsc';
      }
    },
    togglePageSort() {
      if (this.sort === 'pageAsc') {
        this.sort = 'pageDesc'
      }
      else if (this.sort ==='pageDesc') {
        this.sort = 'pageAsc'
      } else {
        this.sort = 'pageAsc';
      }
    },
    applyPageFilter() {
      this.pageFilter = this.$refs.filterInput.value.toLowerCase();
    },
    clearPageFilter() {
      this.pageFilter=null;
      this.$refs.filterInput.value = '';
    },
  },
  computed: {
    shareEmailLink() {
      const pageUrl = this.resultData.initialLinks && this.resultData.initialLinks[0];
      const subject = encodeURIComponent('PageCheckup.com results for: ' + pageUrl);
      const body = encodeURIComponent("Hi, I ran an affiliate link scan on my site and thought you would be interested in the result: http://www.pagecheckup.com/results/" + this.crawlId + '/pages');
      
      return "mailto:?subject="+subject+"&body="+body;
    },
    productSortClasses() {
      return {
        'bi-caret-down-fill': this.sort === 'productDesc',
        'bi-caret-up-fill':  this.sort === 'productAsc'
      }
    },
    pageSortClasses() {
      return {
        'bi-caret-down-fill': this.sort === 'pageDesc',
        'bi-caret-up-fill':  this.sort === 'pageAsc'
      }
    },
    sortedFilteredAmazonItems() {
      if (! this.filteredAmazonItems) {
        return [];
      }

      const sortedFilteredAmazonItems = this.filteredAmazonItems.slice(0).sort(
        (firstEl, secondEl) => {
          if (this.sort === 'productAsc') {
            return (
              firstEl.uniqueMetadataList.length -
              secondEl.uniqueMetadataList.length
            );
          }
          if (this.sort === 'productDesc') {
            return (
              secondEl.uniqueMetadataList.length -
              firstEl.uniqueMetadataList.length
            );
          }

          if (this.sort === 'pageDesc') {
            return ("" + secondEl.url).localeCompare(firstEl.url);
          }

          // Default page asc
          return ("" + firstEl.url).localeCompare(secondEl.url);

        }
      );

      return sortedFilteredAmazonItems;
    },
    filteredAmazonItems() {
      let filteredAmazonItems = this.resultData.amazonItems;

      filteredAmazonItems = this.filterItemsByPage(filteredAmazonItems);
      filteredAmazonItems = this.filterItemsByProduct(filteredAmazonItems);
      filteredAmazonItems = this.filterItemsByAffiliateTagMismatch(filteredAmazonItems);

      return filteredAmazonItems;
    },
  }
};
</script>
